import { CellAlign, HeadCell } from '@dfl/mui-admin-layout';
import { ReactLink } from '@dfl/react-security';
import { Box } from '@mui/material';
import { AvatarMedia } from 'components/AvatarMedia';
import { ClientRowActions } from 'modules/client/management/components/ClientRowActions';
import ClientStatusChip from 'modules/client/management/components/ClientStatusChip/ClientStatusChip';
import { SPACE_PERMISSIONS } from 'modules/client/management/constants/client.permissions';
import { IClient } from 'modules/client/management/interfaces';
import MunicipalityStringValue from 'modules/common/components/MunicipalityStringValue/MunicipalityStringValue';
import ProvinceStringValue from 'modules/common/components/ProvinceStringValue/ProvinceStringValue';

export const clientNameColumn: HeadCell<IClient> = {
  field: 'name',
  headerName: 'client:fields.name',
  disablePadding: false,
  renderCell: (name: string, data: IClient) => (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      }}
    >
      <AvatarMedia avatar={data.avatar} name={data.name} sx={{ mr: 2 }}></AvatarMedia>
      <ReactLink key={data._id} to={`/client/${data._id as string}/general`}>
        {name}
      </ReactLink>
    </Box>
  ),
};

export const clientProvinceColumn: HeadCell<IClient> = {
  field: 'contact.address.state',
  headerName: 'client:fields.state',
  renderCell: (state: string) => <ProvinceStringValue provinceCode={state} />,
};

export const clientMunicipalityColumn: HeadCell<IClient> = {
  field: 'contact.address.municipality',
  headerName: 'client:fields.municipality',
  renderCell: (municipality: string, data: IClient) => (
    <MunicipalityStringValue provinceCode={data.contact.address.state} municipalityCode={municipality} />
  ),
};

export const clientAddressColumn: HeadCell<IClient> = {
  field: 'contact.address.address',
  headerName: 'client:fields.address',
};

export const clientStatusColumn: HeadCell<IClient> = {
  field: 'active',
  headerName: 'client:fields.status',
  renderCell: (active: boolean, data: IClient) => <ClientStatusChip key={data._id} value={data.active} />,
};

export const clientActionsColumn: HeadCell<IClient> = {
  field: 'actions',
  sortable: false,
  width: 100,
  permissions: SPACE_PERMISSIONS.SPACE_WRITE,
  headerName: 'common:actions',
  disablePadding: false,
  align: CellAlign.CENTER,
  component: ClientRowActions,
};

export const clientColumns: Array<HeadCell<any>> = [
  clientNameColumn,
  clientProvinceColumn,
  clientMunicipalityColumn,
  clientAddressColumn,
  clientStatusColumn,
  clientActionsColumn,
];
